import React, { useState } from 'react';
import CompanyLayout from '../../components/Company/CompanyLayout';
import Card from '../../components/UI/Card';
import Button from '../../components/UI/Button';
import FileUploader from '../../components/ATS/FileUploader';
import * as companyResumeService from '../../services/companyResumeService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function UploadResumes() {
	const [files, setFiles] = useState([]);
	const [uploading, setUploading] = useState(false);
	const [results, setResults] = useState(null);
	const navigate = useNavigate();

	function onFileSelect(file) {
		setFiles((fs) => [...fs, file]);
	}

	async function handleUpload() {
		if (!files.length) {
			toast.error('Select files first');
			return;
		}
		setUploading(true);
		try {
			const res = await companyResumeService.uploadResumes(files);
			toast.success(`Uploaded ${res.uploaded || res.uploaded?.length || files.length} resumes`);
			setResults(res);
		} catch {
			toast.error('Upload failed');
		} finally {
			setUploading(false);
		}
	}

	return (
		<CompanyLayout>
			<div className="space-y-6">
				<header className="flex items-center justify-between">
					<h1 className="text-2xl font-bold">Upload Candidate Resumes</h1>
				</header>

				<Card title="Bulk Upload">
					<FileUploader onFileSelect={onFileSelect} />
					{files.length > 0 && (
						<div className="mt-3">
							<p className="text-sm text-gray-600">Files:</p>
							<ul className="list-disc ml-5 text-sm">
								{files.map((f, i) => (
									<li key={i} className="flex items-center justify-between">
										<span>{f.name}</span>
										<button className="text-red-600 text-xs" onClick={() => setFiles((fs) => fs.filter((_, k) => k !== i))}>
											Remove
										</button>
									</li>
								))}
							</ul>
						</div>
					)}
					<div className="mt-3">
						<Button onClick={handleUpload} loading={uploading}>
							Upload
						</Button>
					</div>
				</Card>

				{results && (
					<Card title="Results">
						<p className="text-sm text-gray-600">Uploaded: {results.uploaded?.length || '-'}</p>
						<div className="mt-3">
							<Button variant="secondary" onClick={() => navigate('/company/resumes')}>
								View Candidates
							</Button>
						</div>
					</Card>
				)}
			</div>
		</CompanyLayout>
	);
}


